export default {
    Custom: {
        id: "0",
        label: 'Custom',
        translationKey: 'custom'
    },
    Template: {
        id: "1",
        label: 'Template',
        translationKey: 'template'
    }
};
